import { defer } from 'react-router-dom'
import { isAppStateReady } from 'src/state/store'
import { logger } from '$utils'
import useWorkforceStore from '../store'

export default async function loader() {
  logger.debug(
    '[loader] About to await AppState being ready in StaffMembers loader'
  )
  await isAppStateReady()
  logger.debug('[loader] AppState should now be ready in StaffMembers loader')

  const getStaffMembers = useWorkforceStore
    .getState()
    .getStaffMembers(useWorkforceStore.getState().showDeactivated, true)

  const getPosStaffMembers = useWorkforceStore.getState().getPosStaff(true)

  const getStaffRoles = useWorkforceStore.getState().getStaffRoles(false)

  return defer({
    data: Promise.all([getStaffMembers, getPosStaffMembers, getStaffRoles])
      .then(() => true)
      .catch((error) => {
        logger.error('Staff Members Promise.all error', error)
        return false
      }),
  })
}
